import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.individualAnswer.loading;
export const individualAnswerErrorMessage = (state: RootState) =>
  state.individualAnswer.error;
export const individualAnswerDataResponse = (state: RootState) =>
  state.individualAnswer.individualAnswerResponse;
